module.exports = __webpack_public_path__ + "static/mobile-affordability-bg.649d6edc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/mobile-affordability-bg.jpg
// module id = 592
// module chunks = 35783957827783